export default __webpack_public_path__ + "static/media/Tesla.50538842.PNG";